import Routine, { RUN } from "@bloglovin/inspire-engine/Routine";

/**
 * PowerOnVm — user-initiated VM power-on.
 *
 * Server-only: the real work is the GCP devbox create in PowerOnVm.php.
 * Registered on the client for engine PHP/JS parity and so the
 * <EntityAction> fires the event optimistically; the browser holds no
 * GCP credentials, so the client counterpart is a no-op. The server's
 * SetProjectVmStatus(initializing) broadcast flips the panel.
 */
export default class PowerOnVm extends Routine {
  // Client no-op stub: the server (PowerOnVm.php / PowerOffVm.php) resolves
  // + validates the real params (vmName/gcpProject/stateBucket/createScriptPath)
  // and does the GCP work. The old assertObjectKeyExists("project") check was
  // stale from a prior param design and threw before the transaction could post.
  assertValidParams() {}

  [RUN]() {
    return null;
  }
}

Routine.register("PowerOnVm", PowerOnVm);
